// src/components/AboutUs.js
import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <section id="about" className="about">
      <div className="about-content">
        <h2>About Codex Crew</h2>
        <p>
          Codex Crew is a student-led coding club dedicated to empowering the next
          generation of developers. We organize workshops, hackathons, and coding
          challenges to help students sharpen their skills and become innovators
          in the world of technology.
        </p>
      </div>
    </section>
  );
};

export default AboutUs;
